<template>
<div>
 <Toolbar class="contenttopbar"  v-if="$store.state.questions.question">
<template #start>
<h3 class="text-primary mb-2 mt-2 font-medium">{{$store.state.questions.question.name}}: {{$store.state.languages.lang_phrases.secenekler}}</h3>
</template>
<template #end>



<div class="hide_on_mobile">
<Button type="button" class="p-button-primary p-button-outlined p-button-sm" label="Yeni Ekle" icon="pi pi-plus" @click="gotoPage('QuestionOption')" />
<Button type="button" class="p-button-primary p-button-outlined p-button-sm ml-2" label="Toplu Yükle" icon="pi pi-cloud-upload" @click="showModal" />
</div>

<div class="show_on_mobile">
<Button type="button" class="p-button-primary p-button-outlined p-button-sm"  icon="pi pi-plus" @click="gotoPage('QuestionOption')" />
<Button type="button" class="p-button-primary p-button-outlined p-button-sm ml-2"  icon="pi pi-cloud-upload" @click="showModal" />
</div>




</template>
</Toolbar>



<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">
<div class="mt-4">

<draggable 
v-model="items"
class="list-group" 
@start="start" 
@end="end" 
v-bind="dragOptions"
item-key="id">
<template #item="{element}">
<div class="grid p-2">
<div class="col-12 section_wrap" :class="{'deactive_line':!element.active }">
<div class="grid pt-1 pb-1" >
<!--name-->
<div class="col-10 md:col-11 pl-3 sortable_element_section_name pt-1 pb-0"  @click="gotoPage('QuestionOption',{option_id:element.id})">
<p class="text-primary mt-1 mb-0 pt-1"><b>{{element.name}} <span v-if="element.points!==0 || element.points!==null" class="primary-text"> - {{element.points}} %</span></b></p>
</div>
<!--name-->


<!-- button menu-->
<div class="col-2 md:col-1 sortable_element_section_name pt-1 pb-0">
<div class="flex justify-content-end flex-wrap pr-3">
<Button type="button"  icon="pi pi-ellipsis-h" @click="toggle($event,element.id)" aria-haspopup="true" :aria-controls="'line_menu'+element.id" class="p-button-primary p-button-text p-button-sm mt-03"   />
<Menu :id="'line_menu'+element.id"  :ref="'menu'+element.id" :model="inputfielddropdown" :popup="true">
<template #item="{item}">  
<a class="p-menuitem-link" role="menuitem" @click="item.command(element.id)">
<span :class="'p-menuitem-icon '+item.icon"></span>
<span class="p-menuitem-text">{{item.label}}</span>
<span class="p-ink"></span></a>
</template>
</Menu> 
</div>
</div>
<!-- button menu-->



</div>
</div>
</div>
</template>
</draggable>

</div>
</template>

<OptionUploadModal ref="optionuploadmodal" @uploadCompeted="getData"> </OptionUploadModal>

 </div> 
</template>

<script>
import OptionUploadModal from "./OptionUploadModal"
export default {

  name: 'QuestionOptions',

  data () {
    return {
      items:[],
      loading:true,
      drag:false,
      inputfielddropdown: [
        {
                label: 'Düzenle',
                icon: 'pi pi-pencil',
                route:"QuestionOption",
                command: (id) => {
                     this.gotoPage("QuestionOption",{option_id:id})
                  }
            },
            {
                label: 'Sil',
                icon: 'pi pi-trash',
                argument:"inputfieldoption",
                command: (id) => {
                     this.deleteItem("inputfieldoption",id)
                  }
            },
      ],
    }
  },
  components:{OptionUploadModal},
  computed:{
    headerurlparams()
    {
      return {id:this.$store.state.questions.question.questionlist_id}
    },
     dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost"
      };
    },
    deletedstate()
    {
      return this.$store.state.ui.deletedstate
    }
  },
   watch:{
    deletedstate(newVal,oldVal)
    {
      if(newVal)
      {
        this.getData()
      }
    }
  },
  mounted()
  {
    this.getData()
  },
  methods:{
    showModal()
    {
      this.$refs.optionuploadmodal.showModal()
    },
    toggle(event,id) {
        this.$refs['menu'+id].toggle(event);
    },
    end(event)
    {     
      console.log(this.items)
      //return false
      let formdata = new FormData()
      formdata.append("items",JSON.stringify(this.items)) 
      this.generalSubmission(formdata,"questionlists/inputfield/options/reorder/"+this.$route.params.option_id,this.afterSubmit)

      this.drag = false
    },
    afterSubmit(response)
    {
      console.log(response.data);
    },
    start(event)
    {

      this.drag = false
    },
    async getData()
    {
        this.items = await this.generalApiGetWithoutLoader("questionlists/inputfield/options/"+this.$route.params.id)
        console.log(this.items)

        this.loading = await false
    },  
     dataChanged(data,id)
    {
      console.log(id);
      console.log(data)
      let formdata = new FormData()
      formdata.append(data.key,data.value)      
      this.generalSubmission(formdata,"questionlists/inputfield/translations/"+id,this.afterdataChanged)
    },
    afterdataChanged(response)
    {
      console.log("data changed");
      console.log(response);      
      this.items = response.data
      
    },
  }
};
</script>

<style lang="css" scoped>
</style>